<template>

  <div class="main-menu menu-fixed menu-accordion menu-shadow " :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'light'|| skin === 'bordered' ? 'menu-light' : 'menu-dark'
    ]" @mouseenter="updateMouseHovered(true)" @mouseleave="updateMouseHovered(false)">


    <div class="navbar-header expanded ">
      <slot name="header" :toggleVerticalMenuActive="toggleVerticalMenuActive" :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon">
        <ul class="nav navbar-nav ">

          <li class="nav-item flex-grow-1">
            <b-link class="navbar-brand  w-100 justify-content-center" to="/">
              <span class="brand-logo justify-content-start d-flex">

                <template
                  v-if="isVerticalMenuCollapsed && !isMouseHovered && isVerticalMenuActive && windowWidth >= 1200">
                  <b-img :src="appLogoShort" alt="logo" />
                </template>

                <template v-else>
                  <article class="d-flex flex-column justify-content-center align-items-center " >
                    <logo white short />
                    <b-img :src="logo" alt="logo" />
                  </article>

                </template>

              </span>
            </b-link>
          </li>

          <li class="nav-item nav-toggle d-flex justify-content-end flex-grow-0 ">
            <b-link class="nav-link modern-nav-toggle my-0 ms-auto me-0">
              <font-awesome-icon icon="xmark" size="lg" class="d-block d-xl-none" @click="toggleVerticalMenuActive" />
              <font-awesome-icon :icon="['fas', collapseTogglerIconFeather]" size="lg"
                class="d-none d-xl-block collapse-toggle-icon" @click="toggleCollapsed" />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>

    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{'d-block': shallShadowBottom}" class="shadow-bottom" />

    <!-- main menu content-->

    <ul class="main-menu-content scroll-area ">
      <vertical-nav-menu-items :items="navMenuItems" class="navigation navigation-main" />
    </ul>
    <!-- /main menu content-->
  </div>
</template>

<script setup>

import useAppConfig from '@/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
// import logoFavicon from 'images/logoFavicon.png'
import useAppStore from '@/store/app'
import Logo from 'components/Logo.vue';

const app_store = useAppStore();

const props = defineProps({
  isVerticalMenuActive: {
    type: Boolean,
    required: true,
  },
  toggleVerticalMenuActive: {
    type: Function,
    required: true,
  },
  navMenuItems: {
    type: Array,
    required: true,
  },
});

const {
  isMouseHovered,
  isVerticalMenuCollapsed,
  collapseTogglerIcon,
  toggleCollapsed,
  updateMouseHovered,
} = useVerticalNavMenu(props)
      

const { windowWidth } = toRefs(app_store)
const { skin } = useAppConfig()

// Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
const shallShadowBottom = ref(false)

provide('isMouseHovered', isMouseHovered)


const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'circle' : 'circle-dot'))

// App Name
const { appName, appLogoImage, applogoImageWhite, appLogoShort } = $themeConfig.app



const logo = computed(() => skin.value == 'dark' || skin.value == 'light' ? applogoImageWhite : appLogoImage)
   
</script>

<style lang="scss">
@use "@variables/variables" as *;
@import "@/assets/scss/base/core/menu/menu-types/vertical-menu.scss";

.main-menu{
    background: $color-fondo-menu-2 !important;
    .navbar-header {
        .nav.navbar-nav {
    
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
    
          li:first-child {
            flex: 1 1 200px;
          }
    
          li.nav-toggle {
            flex: 1 1 30px;
            align-self: flex-start;
          }
          
          .brand-logo img {
            width: 80px;
            max-width: calc($menu-collapsed-width);
            height: 50px;
            object-fit: contain;
            padding: none;
          }
    
        }
  }

  &.expanded{

    .brand-logo img{
        max-width: calc($menu-expanded-width - ($menu-padding-left * 4)) !important;
    }
  }


}


@media (min-width:350px){
  .main-menu{
    .navbar-header {
        .nav.navbar-nav {
          .brand-logo img {
            width: 100px;
          }
        }
      }
  }
}

@media (min-width:370px){
  .main-menu{
    .navbar-header {
        .nav.navbar-nav {
        

          .brand-logo img {
            width: 130px;
            
          }
        }
      }
  }
}

@media (min-width:420px){
  .main-menu{
    .navbar-header {
        .nav.navbar-nav {
         
          .brand-logo img {
            width: 170px;
          }
        }
      }
  }
}


@media (min-width:720px){
  .main-menu{
      .navbar-header {
          .nav.navbar-nav {
            .brand-logo img {
              width: 180px;
            }
          }
      }
  }
}
</style>
